/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Restorefailed1Inputs */

const zh_subscription_restorefailed1 = /** @type {(inputs: Subscription_Restorefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复订阅失败`)
};

const en_subscription_restorefailed1 = /** @type {(inputs: Subscription_Restorefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to restore subscription`)
};

const es_subscription_restorefailed1 = /** @type {(inputs: Subscription_Restorefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al restaurar la suscripción`)
};

/**
* | output |
* | --- |
* | "Failed to restore subscription" |
*
* @param {Subscription_Restorefailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_restorefailed1 = /** @type {((inputs?: Subscription_Restorefailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Restorefailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_restorefailed1(inputs)
	if (locale === "en") return en_subscription_restorefailed1(inputs)
	return es_subscription_restorefailed1(inputs)
});
export { subscription_restorefailed1 as "subscription_restoreFailed" }